import { render, staticRenderFns } from "./user-panel.vue?vue&type=template&id=98f52c2a&"
import script from "./user-panel.vue?vue&type=script&lang=js&"
export * from "./user-panel.vue?vue&type=script&lang=js&"
import style0 from "./user-panel.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports